import axios from 'axios'
import { Granularity } from 'types/chart'
import { GetPriceHistoryResponse, BoltApiResponseBody } from 'types/bolt-api/request'
import { PriceHistoryMetrics } from 'components/charts/price-history/types'

/**
 * Get the price history data
 *
 * @param {Granularity} granularity
 * @param {string} from
 * @param {string} until
 * @param {'kWh' | 'MWh'} unit
 * @returns {Promise<GetPriceHistoryResponse | null>}
 */
const getPriceHistory = async (
  granularity: Granularity,
  from: string,
  until: string,
  unit?: 'kWh' | 'MWh'
): Promise<PriceHistoryMetrics | null> => {
  try {
    const {
      data: { success, data }
    } = await axios.get<BoltApiResponseBody<GetPriceHistoryResponse>>(
      `${process.env.API_URL}/metrics/price-history?granularity=${granularity}&from=${from}&until=${until}&unit=${unit || 'MWh'}`,
      {
        headers: {
          Authorization: `Basic ${process.env.API_TOKEN}`
        }
      }
    )

    return success && data?.priceHistory ? data.priceHistory : null
  } catch (_) {
    return null
  }
}

export default getPriceHistory
